import type { Messages } from "../types";

export const pl = {
  "common": {
    "brand": "UN8",
    "brandTag": "Ekskluzywne randki chrześcijańskie",
    "continue": "Kontynuować",
    "leave": "Wyjechać",
    "leaveForNow": "Zostaw na razie",
    "yes": "Tak",
    "no": "NIE",
    "goBack": "Wracać",
    "saving": "Oszczędność…",
    "submitting": "Przedkładający…",
    "pleaseWait": "Proszę czekać…",
    "ellipsis": "…",
    "male": "Mężczyzna",
    "female": "Kobieta",
    "phases": {
      "gate": "Brama",
      "verify": "Zweryfikować",
      "setup": "Organizować coś",
      "profile": "Profil"
    },
    "storageQuota": "W tym telefonie brakuje miejsca na zapisane odpowiedzi. Zwolnij trochę miejsca i spróbuj ponownie.",
    "storageDisabled": "Ta przeglądarka nie zapisze Twoich odpowiedzi. Wyłącz tryb prywatny lub zezwól na dane witryny, a następnie załaduj ponownie.",
    "charMeta": "{len}/{min} min · {current}/{max}",
    "charMetaMin": "min {min} znaków"
  },
  "welcome": {
    "promise": "Naszym celem jest jak najszybsze usunięcie tej aplikacji.",
    "sub": "UN8 pomaga poważnym samotnym chrześcijanom znaleźć partnera życiowego – a następnie odejść. Zweryfikowano. Wartości-najpierw. Żadnego niekończącego się przesuwania.",
    "signedInAs": "Zalogowano się jako {email}",
    "liveServer": "· Serwer na żywo",
    "deviceOnly": "· tylko to urządzenie",
    "migrateOffer": "To urządzenie nadal ma profil lokalny. Przesłać go na udostępniony serwer, aby inne telefony mogły Cię zobaczyć po moderacji? Nic nie zostanie przesłane, dopóki nie wybierzesz.",
    "uploadLocalProfile": "Prześlij mój profil lokalny",
    "keepOnDevice": "Trzymaj go tylko na tym urządzeniu",
    "migrateNeedGender": "Najpierw wybierz w swoim profilu opcję Mężczyzna lub Kobieta.",
    "migrateDone": "Przesłano tekst profilu. Prześlij ponownie dokument tożsamości, film i zdjęcia, aby moderacja mogła je sprawdzić.",
    "deleteConfirm": "Trwale usunąć swoje konto, wszystkie wiadomości i wszystkie multimedia (w tym identyfikatory i filmy) z serwera?",
    "accountDeleted": "Konto usunięte.",
    "begin": "Zaczynać",
    "continueOnboarding": "Kontynuuj wdrażanie",
    "logIn": "Zaloguj się",
    "logOut": "Wyloguj się",
    "reviewConsole": "Przejrzyj konsolę",
    "matching": "Dopasowanie",
    "deleteMyAccount": "Usuń moje konto"
  },
  "faith": {
    "eyebrow": "Brama wiary",
    "title": "Tylko chrześcijanie",
    "text": "UN8 to społeczność naśladowców Jezusa Chrystusa, zrzeszająca członków poszukujących partnera o nastawieniu małżeńskim, podzielającego tę wiarę. Tej bramki nie da się ominąć.",
    "yesTitle": "Jestem chrześcijaninem",
    "yesBody": "Podążam za Jezusem Chrystusem i szukam partnera nastawionego na małżeństwo, który podziela tę wiarę.",
    "noTitle": "Nie jestem chrześcijaninem",
    "noBody": "UN8 nie jest dla mnie właściwym miejscem — i to jest w porządku.",
    "respectTitle": "Z szacunkiem",
    "respectBody": "UN8 jest zbudowany dla jednej społeczności i wolimy być szczerzy, niż marnować Twój czas. Użyj opcji Opuść poniżej lub Wstecz, jeśli to nie jest Twój dom.",
    "sharedTitle": "Wspólna podstawa",
    "sharedBody": "Wiara nie jest tu etykietą. To jest ziemia, na której się spotykacie.",
    "hintNotChristian": "UN8 jest przeznaczony dla naśladowców Jezusa Chrystusa. Kliknij opcję Opuść poniżej lub wybierz opcję chrześcijańską, jeśli to Ty.",
    "hintUnset": "Kliknij „Jestem chrześcijaninem”, aby kontynuować, lub „Wyjdź/Wróć”, jeśli to nie jest Twój dom."
  },
  "rules": {
    "eyebrow": "Przymierze wspólnotowe",
    "title": "Jak się nawzajem traktujemy",
    "text": "Potwierdź każdą zasadę. Wszystkie trzy są wymagane. Naruszenia prowadzą do trwałego usunięcia. Fałszywe profile są blokowane na zawsze.",
    "agreeContinue": "Zgadzam się – kontynuuj",
    "respectful": {
      "title": "Okazuj szacunek",
      "description": "Mów i postępuj z godnością. Każdy tutaj jest stworzony na obraz Boga."
    },
    "noSexualContent": {
      "title": "Żadnych treści seksualnych",
      "description": "Żadnych wyraźnych zdjęć, wiadomości ani próśb. Czystość nie jest tutaj opcjonalna."
    },
    "noDominance": {
      "title": "Nie dominuj i nie kontroluj",
      "description": "Żadnych przymusów, manipulacji i nacisków. Miłość nie kontroluje."
    },
    "hint": "Zanim będziesz kontynuować, zaznacz wszystkie trzy obietnice."
  },
  "intent": {
    "eyebrow": "",
    "title": "Czego szukasz?",
    "text": "",
    "marriage": {
      "label": "Partnera na całe życie",
      "description": ""
    },
    "discernment": {
      "label": "Poważne rozeznanie",
      "description": ""
    },
    "notCasual": {
      "label": "Nic przypadkowego",
      "description": ""
    },
    "hint": "Wybierz jedno."
  },
  "account": {
    "eyebrow": "Konto",
    "title": "Utwórz swój dostęp",
    "text": "Twój uchwyt tworzy stabilny identyfikator użytkownika. Aplikacja, weryfikacja, polubienia i dopasowania są powiązane z tym identyfikatorem. Żaden e-mail nie jest wysyłany.",
    "recoveryTitle": "Zapisz swój kod odzyskiwania",
    "recoveryText": "Pokazany raz. Bez tego utraconego hasła nie można zresetować w tym teście zamkniętym.",
    "savedContinue": "Zapisałem – kontynuuj",
    "handle": "Uchwyt",
    "handlePlaceholder": "ty@example.com lub krótki uchwyt",
    "passphrase": "Hasło",
    "passphrasePlaceholder": "Co najmniej 8 znaków",
    "signedInTitle": "Zalogowano",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Zaufaj standardowi",
    "trustBody": "Żaden profil nie jest widoczny, dopóki nie zakończy się weryfikacja tożsamości i zatwierdzenie Cię przez moderację.",
    "continueToVerification": "Kontynuuj weryfikację",
    "hintEmail": "Wpisz adres e-mail zawierający znak @.",
    "hintPassword": "Wybierz hasło składające się z co najmniej 8 znaków."
  },
  "verify": {
    "intro": {
      "eyebrow": "Weryfikacja",
      "title": "Zaufanie jest bramą",
      "text": "Prześlij dokument tożsamości, film potwierdzający i prawdziwe zdjęcia {min}–{max}. Wszystko trafia do kolejki recenzji, zanim Twój profil będzie mógł się pojawić.",
      "whyTitle": "Dlaczego weryfikujemy",
      "whyBody": "Nie ma tu miejsca na sumowanie i półprawdy. Fałszywe profile są blokowane na stałe. Nośniki są przechowywane ze statusem pending_review do czasu zatwierdzenia.",
      "start": "Rozpocznij weryfikację"
    },
    "steps": {
      "id": {
        "title": "Identyfikator rządowy",
        "description": "Paszport lub dowód osobisty — przesyłanie aparatu lub pliku."
      },
      "video": {
        "title": "Film potwierdzający",
        "description": "Krótkie nagranie potwierdzające Twoją obecność."
      },
      "photos": {
        "title": "Prawdziwe zdjęcia",
        "description": "Siedem do dziesięciu wyraźnych zdjęć siebie."
      },
      "review": {
        "title": "Przegląd integralności",
        "description": "Przesłane pliki pozostają pending_review do czasu potwierdzenia przez personel."
      }
    },
    "id": {
      "eyebrow": "Krok 1 z 4",
      "title": "Identyfikator rządowy",
      "text": "Zdobądź lub prześlij swój paszport lub dowód osobisty. Nic nie jest publikowane publicznie — status pozostaje pending_review do czasu potwierdzenia przez personel.",
      "savedTitle": "Identyfikator zapisany",
      "savedBody": "Następny jest krótki film potwierdzający Twoją twarz, a następnie 7 do 10 prawdziwych zdjęć Twojej osoby. Kontynuuj odblokowuje się, gdy ten identyfikator zostanie zapisany.",
      "hint": "Zrób lub prześlij zdjęcie swojego dokumentu tożsamości i poczekaj, aż pojawi się informacja, że ​​został zapisany."
    },
    "video": {
      "eyebrow": "Krok 2 z 4",
      "title": "Film potwierdzający",
      "text": "Nagraj krótki klip lub prześlij go. Stań twarzą w twarz z kamerą. Mów wyraźnie. To dowodzi, że jesteś obecny — a nie oskrobana galeria.",
      "hint": "Nagraj krótki film potwierdzający, a następnie poczekaj, aż wyświetli się komunikat „Zapisano”."
    },
    "photos": {
      "eyebrow": "Krok 3 z 4",
      "title": "Prawdziwe zdjęcia",
      "text": "Dodaj {min}–10 swoich ostatnich zdjęć. Skorzystaj z aparatu lub swojej biblioteki. Stuknij ×, aby usunąć dowolne ujęcie.",
      "continueToReview": "Kontynuuj recenzję",
      "hint": "Dodaj {min} do 10 wyraźnych zdjęć siebie. Kontynuuj odblokowuje się po zapisaniu."
    },
    "review": {
      "eyebrow": "Krok 4 z 4",
      "title": "Przegląd integralności",
      "text": "Nośnik znajduje się w kolejce jako pending_review{underUser}. Dopasowania i polubienia będą używać tego samego identyfikatora.",
      "underUser": "pod użytkownikiem {userId}",
      "governmentId": "Identyfikator rządowy",
      "confirmationVideo": "Film potwierdzający",
      "photos": "Zdjęcia",
      "missing": "Zaginiony",
      "filesReady": "Pliki {count} gotowe",
      "submittedTitle": "Przesłane do recenzji",
      "submittedText": "Identyfikator aplikacji jest równy identyfikatorowi użytkownika, więc zatwierdź → pula i wzajemne polubienia pozostają zgodne.",
      "submitContinue": "Prześlij i kontynuuj"
    }
  },
  "setup": {
    "eyebrow": "Konfiguracja konta",
    "title": "Powiedz prawdę o sobie",
    "text": "Odpowiedzi te kształtują dopasowanie i pojawiają się w recenzji. Miękkie kłamstwa marnują czas wszystkich – łącznie z Twoim.",
    "beginSetup": "Rozpocznij konfigurację",
    "pillars": {
      "faith": {
        "name": "Wiara",
        "text": "Dlaczego podążasz za Chrystusem."
      },
      "character": {
        "name": "Charakter",
        "text": "Lojalność, uczciwość, pasja, zaangażowanie — ocena 1–10."
      },
      "story": {
        "name": "Historia",
        "text": "Kim jesteś i czego szukasz."
      },
      "life": {
        "name": "Życie",
        "text": "Hobby, czytanie i powołanie."
      }
    },
    "whyChristian": {
      "eyebrow": "Wiara",
      "title": "Dlaczego jesteś chrześcijaninem?",
      "text": "Krótka, szczera odpowiedź. To nie jest kazanie – powód jest twój.",
      "label": "Twoja odpowiedź",
      "placeholder": "np. Spotkałem Chrystusa w czasie straty i podążam za Nim od…",
      "hint": "Napisz co najmniej {min} znaków, dlaczego podążasz za Jezusem."
    }
  },
  "scales": {
    "eyebrow": "Skale znaków",
    "title": "Oceń siebie szczerze",
    "text": "Lojalność, uczciwość, pasja, zaangażowanie – każda od 1 do 10. Nadmuchywanie liczb tylko później sprawi, że nie dopasujesz się do siebie. Aby kontynuować, musisz ustawić każdą skalę.",
    "loyalty": {
      "label": "Poziom lojalności",
      "hint": "Bądź szczery – jak wiernie stoisz po stronie tych, których kochasz?"
    },
    "honesty": {
      "label": "Poziom uczciwości",
      "hint": "Jak konsekwentnie mówisz całą prawdę?"
    },
    "passion": {
      "label": "Jak bardzo jesteś pasjonatem?",
      "hint": "Przekonanie i głębia – nie wydajność."
    },
    "commitment": {
      "label": "Poziom zaangażowania",
      "hint": "Jak bardzo jesteś gotowy na zbudowanie czegoś, co będzie trwałe?"
    },
    "hint": "Przesuń każdy suwak tak, aby wyświetliła się liczba — żaden nie może pozostać myślnikiem."
  },
  "about": {
    "eyebrow": "O tobie",
    "title": "Opisz siebie w kilku zdaniach",
    "text": "Kim jesteś, gdy nikt nie występuje. Temperament, rytm, to co liczy się na co dzień.",
    "label": "O tobie",
    "placeholder": "Spokojne poranki, poważne podejście do rodziny, łatwo się śmiejesz, wolisz głębię od hałasu…",
    "hint": "Napisz o sobie co najmniej {min} znaków."
  },
  "looking": {
    "eyebrow": "Partner",
    "title": "Czego Pan szuka?",
    "text": "Główne cechy charakteru, jakich pragniesz u potencjalnego partnera – a nie lista zakupów dotycząca wyglądu.",
    "label": "Pożądane cechy charakteru",
    "placeholder": "np. Niezłomna wiara, dojrzałość emocjonalna, życzliwość w obliczu stresu…",
    "hint": "Napisz co najmniej {min} znaków o partnerze, na którego liczysz."
  },
  "loveReady": {
    "eyebrow": "Próg",
    "title": "Czy jesteś gotowy na spotkanie miłości swojego życia?",
    "text": "UN8 istnieje, więc poważne single znajdują partnera — a następnie usuwają aplikację. Only “Yes” unlocks continue.",
    "yesTitle": "Tak – jestem gotowy",
    "yesBody": "Jestem tu, aby spotkać się ze swoją osobą z jasnością i odwagą.",
    "noTitle": "Jeszcze nie",
    "noBody": "Jeśli tylko przeglądasz, ta społeczność nie jest dla Ciebie odpowiednia.",
    "comeBackTitle": "Wróć, gdy będziesz gotowy",
    "comeBackBody": "UN8 jest przeznaczony dla osób przygotowanych na spotkanie, a nie zbieranie opcji. Użyj opcji Opuść poniżej, jeśli chcesz na razie przerwać. Twoje odpowiedzi są zapisywane na tym telefonie.",
    "hintNo": "Tylko „Tak” trwa. Jeśli nie jesteś jeszcze gotowy, stuknij opcję Zostaw na teraz — Twoje odpowiedzi pozostaną w tym telefonie.",
    "hintUnset": "Stuknij Tak, jeśli jesteś gotowy spotkać się z kimś w celu zawarcia małżeństwa."
  },
  "lifestyle": {
    "eyebrow": "Styl życia",
    "title": "Jak żyjesz na co dzień",
    "text": "Sport, hobby, czytanie i zawód — praktyczne sygnały prawdziwej kompatybilności.",
    "hobbies": "Aktualny sport lub hobby",
    "hobbiesPlaceholder": "To, co aktywnie robisz — a nie to, co robiłeś kiedyś.",
    "reading": "Czy czytasz?",
    "readingHint": "1 = prawie nigdy · 10 = codziennie, głębokie czytanie",
    "profession": "Zawód / branża",
    "professionPlaceholder": "np. Pielęgniarstwo · Oprogramowanie · Edukacja · Handel",
    "hintHobbies": "Wymień przynajmniej jeden sport lub hobby, które faktycznie uprawiasz.",
    "hintReading": "Slajd „Czy czytasz?” więc wyświetla się liczba od 1 do 10.",
    "hintProfession": "Wpisz, jaką pracę wykonujesz, nawet krótkie słowo."
  },
  "faithDepth": {
    "eyebrow": "Dopasowanie · Wiara",
    "title": "Jak centralna jest twoja wiara?",
    "text": "Służba Bogu — jak ważna jest w Twoim życiu? Odpowiedz szczerze. Dopasowywanie wykorzystuje to do uzyskania głębi, a nie wydajności.",
    "serving": "Służba Bogu — znaczenie",
    "servingHint": "10%… 100%. Przesuwaj w krokach co 10.",
    "keepsCommandments": "Czy przestrzegasz przykazań?",
    "grewUpInChurch": "Czy dorastałeś w kościele?",
    "churchAttendance": "Obecność w kościele",
    "frequent": {
      "label": "Częsty",
      "hint": "Regularne spotkania z Ciałem Chrystusa."
    },
    "seldom": {
      "label": "Rzadko",
      "hint": "Czasami nie jest to rytm tygodniowy."
    },
    "never": {
      "label": "Nigdy",
      "hint": "Obecnie nie uczestniczy."
    },
    "spreadsGospel": "Czy głosisz ewangelię?",
    "hasIdols": "Czy masz idoli?",
    "hintServing": "Przesuń, jak ważna jest służba Bogu w Twoim życiu.",
    "hintCommandments": "Odpowiedz, czy przestrzegasz przykazań — Tak lub Nie.",
    "hintGrewUp": "Odpowiedz, czy dorastałeś w kościele – tak czy nie.",
    "hintAttendance": "Wybierz, jak często uczęszczasz do kościoła.",
    "hintGospel": "Odpowiedz, czy dzielisz się ewangelią – tak czy nie.",
    "hintIdols": "Odpowiedz, czy masz idoli — Tak czy Nie."
  },
  "character": {
    "eyebrow": "Dopasowanie · Charakter",
    "title": "Kim jesteś w domu",
    "text": "Charakter zalotów — utrzymywanie pokoju, maniery, uczciwość. Wyolbrzymianie odpowiedzi tylko później będzie dla Ciebie niezgodne.",
    "peacemaker": "Czy jesteś rozjemcą?",
    "homebuilder": "Czy jesteś budowniczym domu?",
    "humorous": "Czy jesteś zabawny?",
    "caring": "Opiekuńczy i czuły?",
    "peacefulHome": "Czy chcesz spokojnego domu – wolnego od walk?",
    "manners": "Dobre maniery?",
    "honestyRating": "Ocena uczciwości w tym kwestionariuszu",
    "honestyHint": "1–10 – jak szczerze odpowiadasz?",
    "hintPeacemaker": "Odpowiedz na każde Tak lub Nie, zaczynając od rozjemcy.",
    "hintHomebuilder": "Odpowiedz, czy jesteś budowniczym domu.",
    "hintHumorous": "Odpowiedz, czy jesteś dowcipny.",
    "hintCaring": "Odpowiedz, czy jesteś opiekuńczy i czuły.",
    "hintPeaceful": "Odpowiedz czy chcesz mieć spokojny dom.",
    "hintManners": "Odpowiedz, czy masz dobre maniery.",
    "hintHonesty": "Przesuń swoją ocenę uczciwości od 1 do 10."
  },
  "history": {
    "eyebrow": "Dopasowanie · Historia",
    "title": "Przeszłość i gotowość",
    "text": "Substancje, dzieciństwo, blizny i to, czy jesteś gotowy na trwały związek. Prawda tutaj chroni was oboje.",
    "marijuana": "Czy używałeś marihuany?",
    "lsd": "Czy używałeś LSD?",
    "otherDrugs": "Czy stosowałeś inne leki?",
    "addicted": "Czy byłeś uzależniony?",
    "childhood": "Stabilne, kochające dzieciństwo?",
    "scars": "Jakieś blizny/uszkodzenia?",
    "lasting": "Gotowy na trwały związek?",
    "hintStart": "Odpowiedz na każde Tak lub Nie na tej stronie, zaczynając od góry.",
    "hintLsd": "Odpowiedz na pytanie dotyczące LSD – tak lub nie.",
    "hintOtherDrugs": "Odpowiedz, czy zażywałeś inne narkotyki.",
    "hintAddicted": "Odpowiedz, czy byłeś uzależniony.",
    "hintChildhood": "Odpowiedz, czy Twoje dzieciństwo było stabilne i pełne miłości.",
    "hintScars": "Odpowiedz, czy nosisz blizny.",
    "hintLasting": "Odpowiedz sobie, czy jesteś gotowy na trwały związek."
  },
  "appearance": {
    "eyebrow": "Dopasowanie · Wygląd",
    "title": "Tatuaże",
    "text": "Twoje tatuaże i to, czy tatuaże u partnera są dla Ciebie akceptowalne.",
    "hasTattoos": "Czy masz tatuaże?",
    "acceptsPartner": "Akceptować tatuaże u partnera?",
    "hintHas": "Powiedz, czy masz tatuaże – tak czy nie.",
    "hintAccepts": "Powiedz, czy tatuaże u partnera są dla Ciebie akceptowalne."
  },
  "home": {
    "eyebrow": "Dopasowanie · Dom i ziemia",
    "title": "Ziemia, umiejętności, samowystarczalność",
    "text": "Zioła, uprawa żywności, lasy owocowe, przygotowanie, rolnictwo społecznościowe, konserwowanie, przetrwanie – i wszelkie specjalne umiejętności.",
    "herbKnowledge": "Wiedza o ziołach?",
    "plantOwn": "Czy sadzisz własne owoce i warzywa?",
    "fruitForest": "Interesuje Cię las owocowy?",
    "prepping": "Przygotowanie na nieszczęścia?",
    "communityFarming": "Rolnictwo społecznościowe / niezależne życie?",
    "canning": "Konserwowanie i konserwowanie?",
    "survival": "Umiejętności przetrwania?",
    "specialSkills": "Umiejętności specjalne (opcjonalnie)",
    "specialPlaceholder": "Wszystko inne, co przyniesiesz do domu lub na ziemię…",
    "hintStart": "Odpowiadaj na każde Tak lub Nie dotyczące lądu i umiejętności, zaczynając od góry.",
    "hintPlant": "Odpowiedz, czy sadzisz własne owoce i warzywa.",
    "hintFruitForest": "Odpowiedz, czy interesuje Cię las owocowy.",
    "hintPrepping": "Odpowiedz, czy przygotowujesz się na nieszczęścia.",
    "hintCommunity": "Odpowiedz, czy interesuje Cię rolnictwo społecznościowe.",
    "hintCanning": "Odpowiedz, czy możesz i konserwuj żywność.",
    "hintSurvival": "Odpowiedz, czy masz umiejętności przetrwania."
  },
  "family": {
    "eyebrow": "Dopasowanie · Rodzina",
    "title": "Dzieci, głębia wiary, substancje",
    "text": "Czego potrzebujesz od partnera w zakresie intensywności wiary, dzieci i używania substancji psychoaktywnych w przeszłości.",
    "children": "Dzieci",
    "wants": {
      "label": "Chce dzieci",
      "hint": "Budowanie rodziny jest częścią naszej wizji."
    },
    "doesNotWant": {
      "label": "Nie chce dzieci",
      "hint": "Jasne „nie” dla dzieci."
    },
    "open": {
      "label": "Otwarte",
      "hint": "Wymagający — w żadnym wypadku nie zamknięty."
    },
    "hasLivingWith": {
      "label": "Ma dzieci — mieszka z nimi",
      "hint": "Dzieci są już częścią codziennego życia."
    },
    "requiredFaith": "Minimalny poziom wiary, jakiego potrzebujesz w partnera",
    "requiredFaithHint": "10%… 100%. Twarda brama, gdy obie strony odpowiedziały.",
    "acceptsSubstances": "Zaakceptować przeszłe używanie substancji przez partnera?",
    "hintChildren": "Wybierz jedną kartę dotyczącą dzieci.",
    "hintFaith": "Przesuń minimalny poziom wiary, jakiego oczekujesz od partnera.",
    "hintSubstances": "Powiedz, czy używanie substancji psychoaktywnych przez partnera jest dopuszczalne."
  },
  "ancestry": {
    "eyebrow": "Dopasowanie · Tło",
    "title": "Preferencje tła",
    "text": "Podziel się swoim pochodzeniem i tym, na co jesteś otwarty w partnerze. To tylko kształtuje ranking — nigdy nie ukrywa kogoś z talii.",
    "yourBackground": "Twoje tło (wybierz wszystkie, które mają zastosowanie)",
    "openToPartner": "Otwarty na partnera",
    "codeDesc": "Kod: {code}",
    "anyDesc": "Najsilniejsza preferencja dotycząca szerokości — zalecana w przypadku wątpliwości.",
    "preferenceOnly": "Tylko preferencje — nie brama.",
    "hintOwn": "Zaznacz przynajmniej jedno tło, które Cię opisuje. To tylko pomaga w rankingu — nigdy nikogo nie ukrywa.",
    "hintAccepted": "Zaznacz, na co jesteś otwarty u partnera, lub „Otwarty – bez preferencji”."
  },
  "interests": {
    "eyebrow": "Dopasowanie · Zainteresowania",
    "title": "Co sprawia ci przyjemność",
    "text": "Wybierz przynajmniej jeden. Nakładanie się pomaga w rankingu; milczenie nigdy nie jest karane.",
    "hint": "Zaznacz przynajmniej jedno zainteresowanie."
  },
  "reflection": {
    "eyebrow": "Dopasowanie · Odbicie",
    "title": "Własnymi słowami",
    "text": "Te cztery odpowiedzi są pokazane w całości i nie są punktowane. Napisz co jest prawdą.",
    "describeYourself": "Opisz siebie",
    "lifePurpose": "Cel życia",
    "fifteenYear": "Ty i miłość swojego życia za 15 lat",
    "weaknesses": "Słabe strony",
    "hintDescribe": "Opisz siebie przynajmniej {min} znaków.",
    "hintPurpose": "Napisz swój cel życiowy, używając co najmniej znaków {min}.",
    "hintVision": "Zapisz wizję na 15 lat, używając co najmniej znaków {min}.",
    "hintWeaknesses": "Wymień słabość, używając co najmniej znaków {min}."
  },
  "profile": {
    "eyebrow": "Profil",
    "title": "Kilka niezbędnych rzeczy",
    "text": "Zachowaj prostotę. Płeć jest tutaj binarna – męska lub żeńska – dla wyraźnego dopasowania.",
    "firstName": "Imię",
    "firstNamePlaceholder": "Tak jak chcesz być znany",
    "age": "Wiek",
    "agePlaceholder": "18+",
    "city": "Miasto",
    "cityPlaceholder": "Gdzie masz siedzibę",
    "sex": "Seks",
    "maleBody": "Jestem mężczyzną.",
    "femaleBody": "Jestem kobietą.",
    "hintName": "Wpisz swoje imię (co najmniej dwie litery).",
    "hintAge": "Wiek musi mieć ukończone 18 lat.",
    "hintCity": "Wpisz miasto, w którym mieszkasz.",
    "hintGender": "Wybierz mężczyznę lub kobietę, aby dopasowanie mogło zadziałać."
  },
  "ready": {
    "title": "Możesz wejść.",
    "textNamed": "{name}, Twoja weryfikacja i konfiguracja zostały zarejestrowane. Nośnik to pending_review. Witamy w UN8 — znajdź swoją osobę, a następnie usuń aplikację.",
    "text": "Twoja weryfikacja i konfiguracja zostaną zarejestrowane. Nośnik to pending_review. Witamy w UN8 — znajdź swoją osobę, a następnie usuń aplikację.",
    "summaryAria": "Podsumowanie konfiguracji",
    "christianRules": "Chrześcijanin · zasady potwierdzone",
    "mediaLine": "ID · wideo · Zdjęcia {photoCount} · Kolejka {pending}",
    "scalesLine": "Wagi L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Seks —",
    "professionFallback": "zawód",
    "userLine": "Użytkownik {userId}",
    "enterMatching": "Wpisz dopasowanie",
    "needGender": "Wróć do kroku profilu i wybierz opcję Mężczyzna lub Kobieta, a następnie spróbuj ponownie."
  },
  "match": {
    "brandTag": "Dopasowanie",
    "navOnboarding": "Proces wdrażania do firmy nowego pracownika",
    "navReview": "Recenzja",
    "navMatching": "Dopasowanie",
    "logOut": "Wyloguj się",
    "enterTitle": "Wpisz dopasowanie",
    "enterText": "Zaloguj się przy użyciu tego samego adresu e-mail, który został podany podczas onboardingu. Aplikacja, pula, polubienia i dopasowania korzystają ze stabilnego identyfikatora użytkownika.",
    "email": "E-mail",
    "emailPlaceholder": "ty@example.com",
    "password": "Hasło",
    "passwordPlaceholder": "Twoje hasło",
    "logIn": "Zaloguj się",
    "guestOr": "Lub wypróbuj sesję gościa (stabilny identyfikator dla przeglądarki · tylko wersja demonstracyjna)",
    "guestMan": "Gość jako człowiek",
    "guestWoman": "Gość jako kobieta",
    "goOnboarding": "Przejdź do onboardingu →",
    "guestSession": "Sesja gościnna · Pula demonstracyjna",
    "packTitle": "Twoja czwórka",
    "packSkip": "Dotknij, aby kontynuować",
    "newSelection": "Nowy wybór",
    "backToFour": "← Wróć do swojej czwórki",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "Człowiek",
    "woman": "kobieta",
    "navSelection": "Wybór",
    "navMessages": "Wiadomości",
    "navProfile": "Profil",
    "tabToday": "Wybór",
    "tabMatches": "Dopasowania ({count})",
    "yourMatches": "Twoje mecze",
    "matchesSub": "Stałe wzajemne zainteresowanie · {count} wychodzące {likesWord}",
    "like": "tak jak",
    "likes": "upodobania",
    "emptyMatches": "Nie ma jeszcze wzajemnego zainteresowania. Rozważaj dalej wybór z tego tygodnia.",
    "valuesScore": "Wartości {score}",
    "chatOpen": "· Czat otwarty",
    "tapToChat": "· Kliknij, aby porozmawiać",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Wartości {score}",
    "noProfileYet": "Jeszcze nie ma profilu",
    "noProfileText": "Zakończ wdrażanie lub dotknij opcji Dołączenie u góry, a następnie Rozpocznij. Jeśli chcesz tylko sprawdzić, dopasowywanie gości jest na ekranie wprowadzania.",
    "matchingPaused": "Dopasowywanie wstrzymane",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Nie ma jeszcze nikogo do pokazania",
    "todaysSetDone": "To wybór z tego tygodnia",
    "weeklyTitle": "Twoje 4 w tym tygodniu",
    "weeklyTitleCount": "Twoje {count} w tym tygodniu",
    "weeklyCountdown": "Następny wybór za {days} dni",
    "weeklyCountdownOne": "Następny wybór za 1 dzień",
    "weeklyCountdownSoon": "Następny wybór wkrótce",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "To wybór z tego tygodnia",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "Na liście z tego tygodnia nie ma jeszcze nikogo. Uzupełniamy pulę — otwórz Wybór za chwilę albo wróć, gdy zatwierdzimy więcej osób.",
    "emptyDone": "Przeszedłeś wybór z tego tygodnia. Wróć przy następnym otwarciu albo zresetuj talię.",
    "likesMayNotStick": "Polubienia mogą się nie trzymać.",
    "poolMeta": "Pula: {pool} · Mecze: {matches} · Polubione: {liked}",
    "demoPool": "demonstracja",
    "livePool": "{source} ({count})",
    "resetDeck": "Zresetuj talię",
    "backOnboarding": "Powrót do onboardingu",
    "feedEyebrowDemo": "Wybór tygodnia · Demo",
    "feedEyebrowLive": "Wybór tygodnia · Pula ({source}, {count})",
    "feedTitle": "Rozeznaj ostrożnie",
    "left": "pozostało {count}",
    "pass": "Przechodzić",
    "interested": "Zainteresowany",
    "swipeHint": "Przesuń palcem lub użyj przycisków. Dopasowanie otwiera się tylko wtedy, gdy zainteresowanie jest obustronne i trwałe.",
    "celebrationEyebrow": "Wzajemne zainteresowanie",
    "celebrationTitle": "Pasowałeś",
    "celebrationText": "Oba {self} i {other} wykazały zainteresowanie. Dopasowanie wartości: {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "Czat jest odblokowany dla tego meczu. Zachowaj szacunek – przymierze ponad wygodę.",
    "openChat": "Otwórz czat",
    "keepDiscerning": "Zachowaj rozwagę",
    "cardSeeking": "Szukam",
    "cardHobbies": "Hobby",
    "affinity": "Podobieństwo",
    "valuesScoreLabel": "Wartości punktowe",
    "scoreStrong": "Silne wyrównanie",
    "scoreSolid": "Solidne wyrównanie",
    "scoreModerate": "Umiarkowane wyrównanie",
    "scoreDifferent": "Różne rytmy",
    "characterAxisFoot": "Oś charakteru obejmuje cztery filary",
    "youThem": "Ty {self} · Oni {other}",
    "stampInterest": "Odsetki",
    "stampPass": "Przechodzić",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "Twoje wyniki wartości są zbliżone ({score} wynoszące 100).",
    "explainLegacyFuller": "Pełniejsze „dlaczego” pojawia się, gdy oboje zakończycie dopasowywanie pytań.",
    "explainFaith": "Twoja intensywność wiary jest bliska – z podobną powagą podchodzisz do naśladowania Jezusa.",
    "explainCharacter": "Sposób, w jaki traktujesz ludzi w domu, jest zgodny ze sobą — spokój, maniery i troska.",
    "explainPurpose": "Podobnie oceniłeś swoją uczciwość, co jest oznaką wspólnej powagi.",
    "explainHome": "Interesujesz się ziemią, uprawą żywności lub samowystarczalnym domem.",
    "explainAncestry": "Oboje wolicie podobne pochodzenie rodzinne. To preferencja, a nie filtr — nikt się przed nią nie ukrywa.",
    "explainTemperament": "Twoje zainteresowania i temperament pokrywają się.",
    "explainFallback": "Możliwe jest dopasowanie odpowiedzi, które oboje wypełniliście.",
    "explainOverall": "Ogólne powinowactwo {score} wynoszące 100.",
    "affinityAxes": {
      "faith": "Intensywność wiary",
      "character": "Charakter i zachowanie",
      "purpose": "Ujednolicenie celów życiowych",
      "home": "Dom i samowystarczalność",
      "ancestry": "Podobieństwo kulturowe i pokrewne",
      "temperament": "Dopasowanie temperamentu"
    },
    "scaleAxes": {
      "loyalty": "Lojalność",
      "honesty": "Uczciwość",
      "passion": "Pasja",
      "commitment": "Zobowiązanie"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Pogawędzić",
    "unavailableTitle": "Czat niedostępny",
    "unavailableText": "Brakuje tego dopasowania lub nie należy ono do Twojej sesji.",
    "backToMatches": "Wracając do meczów",
    "backMatches": "← Mecze",
    "valuesSubscriber": "Wartości {score} · Abonent",
    "valuesTrial": "Wartości {score} · Próba",
    "valuesKept": "Wartości {score} · Dopasowanie zachowane",
    "empty": "Przywitaj się ostrożnie. Na współdzielonym backendzie wiadomości są synchronizowane na obu telefonach po wzajemnym dopasowaniu.",
    "placeholder": "Wiadomość {name}…",
    "ariaMessage": "Wiadomość",
    "send": "Wysłać"
  },
  "billing": {
    "paywallCopy": "Po bezpłatnym okresie próbnym zatrzymaj wszystkich, z którymi już się połączyłeś i rozmawiaj dalej. Aby zobaczyć nowe osoby, zasubskrybuj.",
    "signInToMatch": "Zaloguj się, aby skorzystać z dopasowywania.",
    "signInFirst": "Zaloguj się najpierw.",
    "subscriberUntil": "Abonent · do {date}",
    "renewal": "odnowienie",
    "freeTrial": "Bezpłatny okres próbny · {days} dni (kończy się {date})",
    "soon": "Wkrótce",
    "trialEnded": "Wersja próbna zakończona · mecze i czat pozostają otwarte",
    "subscribe": "Subskrybuj · ${price}/mies",
    "subscribeEarly": "Subskrybuj wcześniej · ${price}/mies",
    "activeNote": "Subskrypcja aktywna — możesz ponownie zobaczyć nowe osoby.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Zapisz swój kod odzyskiwania",
    "recoveryText": "Zapisz to teraz. Jest to pokazane raz. Jeśli zgubisz hasło, ten kod to jedyny sposób na jego zresetowanie w teście zamkniętym.",
    "savedContinue": "Zapisałem – kontynuuj",
    "welcomeBack": "Witamy z powrotem",
    "createAccount": "Utwórz swoje konto",
    "intro": "Uchwyt i hasło. Nie są wysyłane żadne e-maile ani SMS-y. Twój identyfikator pozostaje stabilny podczas wdrażania, sprawdzania i dopasowywania.",
    "tabLogin": "Zaloguj się",
    "tabRegister": "Rejestr",
    "handle": "Uchwyt",
    "handlePlaceholder": "ty@example.com lub krótki uchwyt",
    "passphrase": "Hasło",
    "passphrasePlaceholder": "Co najmniej 8 znaków",
    "submitLogin": "Zaloguj się",
    "submitRegister": "Utwórz konto",
    "backWelcome": "Powrót do powitania"
  },
  "options": {
    "origin": {
      "african": "afrykanin",
      "european": "europejski",
      "asian": "Azjatycki",
      "latino": "Latynos/Latynos",
      "middleEastern": "Bliskiego Wschodu",
      "indigenous": "Rdzenny",
      "mixed": "Mieszany",
      "other": "Inny",
      "dutch": "Holenderski",
      "german": "niemiecki",
      "any": "Otwarte – bez preferencji"
    },
    "interest": {
      "prayer": "Modlitwa",
      "worship": "Cześć",
      "reading": "Czytanie",
      "hiking": "Turystyka piesza",
      "music": "Muzyka",
      "cooking": "Gotowanie",
      "farming": "Rolnictwo / ogrodnictwo",
      "sports": "Lekkoatletyka",
      "missions": "Misje",
      "family": "Życie rodzinne",
      "crafts": "Rzemieślnictwo",
      "outdoors": "Na powietrzu"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Tak",
      "no": "NIE"
    },
    "id": {
      "titleEmpty": "Identyfikator rządowy",
      "titleReady": "Identyfikator gotowy",
      "hintEmpty": "Paszport lub dowód osobisty. Zrób zdjęcie na żywo lub wybierz obraz/plik PDF. Widoczne wszystkie cztery rogi.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": "· zapisane",
      "previewAlt": "Podgląd identyfikatora rządowego",
      "pdfAria": "Wybrano dokument PDF",
      "takePhoto": "Zrób zdjęcie",
      "retake": "Odzyskać",
      "chooseFile": "Wybierz plik",
      "replaceFile": "Zamień plik",
      "remove": "Usunąć",
      "uploading": "Przesyłanie…",
      "cameraTitle": "Sfotografuj swój dowód osobisty",
      "signIn": "Zaloguj się przed przesłaniem identyfikatora.",
      "uploadFailed": "Przesyłanie nie powiodło się. Spróbuj ponownie.",
      "badFile": "Nie można użyć tego pliku."
    },
    "video": {
      "titleEmpty": "Film potwierdzający",
      "titleLive": "Kamera na żywo",
      "titleReady": "Wideo gotowe",
      "hintEmpty": "Powiedz swoje imię i szczerze dołącz do UN8. 5–15 sekund.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}",
      "record": "Nagrywać",
      "cameraUpload": "Przesyłanie z aparatu",
      "chooseFile": "Wybierz plik",
      "startRecording": "Rozpocznij nagrywanie",
      "cancel": "Anulować",
      "stopSave": "Zatrzymaj się i zapisz",
      "recordAgain": "Nagraj ponownie",
      "replaceFile": "Zamień plik",
      "remove": "Usunąć",
      "unsupported": "Nagrywanie na żywo jest tutaj niedostępne. Użyj przesyłania z aparatu lub wybierz plik.",
      "permissionDenied": "Odmowa dostępu do aparatu. Nadal możesz przesłać krótki plik wideo.",
      "signIn": "Zaloguj się przed przesłaniem filmu.",
      "uploadFailed": "Przesyłanie nie powiodło się. Spróbuj ponownie.",
      "saveFailed": "Nie udało się zapisać nagrania.",
      "badVideo": "Nie można użyć tego filmu."
    },
    "photos": {
      "count": "Zdjęcia {count} / {max}",
      "minimumMet": "Osiągnięto minimum",
      "moreRequired": "Wymagane jest więcej {n}",
      "listAria": "Zdjęcia weryfikacyjne",
      "photoAlt": "Zdjęcie {n}",
      "removeAria": "Usuń zdjęcie {n}",
      "camera": "Kamera",
      "takePhoto": "Zrób zdjęcie",
      "chooseFiles": "Wybierz pliki",
      "uploading": "Przesyłanie…",
      "hint": "Zrób zdjęcie otwiera kamerę na żywo. Opcja Wybierz pliki dotyczy tylko wybranych galerii. Wyraźne ujęcia twarzy — bez filtrów ukrywających tożsamość. Maks. {max}.",
      "cameraTitle": "Zrób sobie zdjęcie",
      "signIn": "Zaloguj się przed przesłaniem zdjęć.",
      "someFailed": "Nie udało się przesłać niektórych zdjęć. Spróbuj ponownie tych, które się nie powiodły.",
      "addFailed": "Nie udało się dodać zdjęć."
    },
    "liveStill": {
      "titleDefault": "Kamera",
      "close": "Zamknąć",
      "capture": "Schwytać",
      "cancel": "Anulować",
      "hint": "Trzymaj stabilnie. Kamera na żywo pozostaje otwarta do momentu wykonania zdjęcia.",
      "unavailable": "Kamera nie jest dostępna w tej przeglądarce. Zamiast tego użyj opcji Wybierz plik.",
      "permissionDenied": "Odmowa pozwolenia na kamerę lub jest ona niedostępna. Zamiast tego użyj opcji Wybierz plik.",
      "frameFailed": "Nie udało się uchwycić tej klatki.",
      "saveFailed": "Nie udało się zapisać zdjęcia."
    },
    "uploadStatus": {
      "uploading": "przesyłanie…",
      "failed": "przesyłanie nie powiodło się",
      "savedLocally": "zapisane lokalnie",
      "uploaded": "załadowany",
      "stored": "przechowywane",
      "awaitingUpload": "Oczekiwanie na przesłanie",
      "localFallbackNote": "{error} Plik jest zapisany na tym urządzeniu; spróbuj ponownie, gdy punkt końcowy znaku zostanie uruchomiony."
    }
  },
  "language": {
    "label": "Język",
    "choose": "Wybierz język"
  },
  "shell": {
    "back": "Z powrotem",
    "goBackAria": "Wracać"
  }
} as Messages;
